<div class="convite-content novoLayout camera">
  <div class="convite-content-header">
    <div class="logo">
      <img class="img-login" src="assets/img/logo.png" *ngIf="!imgLogo" />
      <img [src]="imgLogo" class="img-login" *ngIf="imgLogo" />
    </div>
  </div>
  <div class="card-align">
    <div class="card my-0 pb-3">
      <div class="container-convite">
        <div class="card-content">
          <h1 class="m-0 pt-3 pb8">{{ "Cadastro Facial" | translate }}</h1>
          <div *ngIf="!pictureData">
            <div
              class="texto02 text-center orientacao-facial"
              [ngClass]="{ liberada: enableCapture }"
              aria-live="polite"
            >
              {{ mensagemOrientacao | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="video-contatiner"
  [ngClass]="{ naoTemCamera: !pictureData, temCamera: pictureData }"
>
  <video
    #video
    autoplay="true"
    muted
    playsinline
    [ngClass]="{ 'flip-video': shouldFaceUser }"
    style="z-index: 1"
  ></video>
  <canvas #canvas style="z-index: 2"></canvas>
</div>

<div *ngIf="pictureData" class="image-contatiner">
  <img [src]="pictureData" />
</div>

<div
  class="top-layer"
  [ngClass]="{ naoTemCamera: !pictureData, temCamera: pictureData }"
>
  <mat-slider
    *ngIf="canZoom"
    vertical
    [value]="zoomValue"
    [max]="zoomMax"
    [min]="zoomMin"
    [step]="zoomStep"
    (change)="onZoomChange($event)"
    [disabled]="pictureData"
  ></mat-slider>
  <div class="flex-fill"></div>
  <div *ngIf="!pictureData && !facialObrigatoria" class="pular-facial-container">
    <button type="button" class="pular-facial" (click)="pular()">
      {{ "FACIAL_CONTINUAR_SEM_CADASTRAR" | translate }}
      <i class="centericon-proximo"></i>
    </button>
  </div>

  <div *ngIf="!pictureData" class="take-picture-container" style="height: 6rem">
    <button
      *ngIf="canSwapCamera"
      class="novoLayout btn-convite-camera"
      (click)="swapCamera()"
      [disabled]="pictureData"
    >
      <i class="centericon-trocar_camera"></i>
    </button>

    <button
      class="btn-captura-facial"
      [disabled]="!enableCapture"
      [attr.aria-disabled]="!enableCapture"
      [attr.aria-label]="mensagemOrientacao | translate"
      (click)="takePicture()"
    >
      <div
        class="btn-redondo-camera"
        [ngClass]="{ ativo: enableCapture, inativo: !enableCapture }"
      >
        <div class="btn-redondo-camera1"></div>
      </div>
    </button>
  </div>

  <mat-toolbar *ngIf="pictureData" class="take-picture-container">
    <div class="acaos-camera-convite pt-3">
      <div class="frase-camera">
        {{ "DESEJA_UTILIZAR_ESSA_IMAGEM" | translate }}
      </div>
      <mat-toolbar-row>
        <div class="btn-acoes novoLayout">
          <button class="btn-repetir" (click)="retake()">
            <i class="centericon-retirar_permissao"></i>
          </button>
          <button class="btn-confirmar" (click)="use()">
            <i class="centericon-check2"></i>
          </button>
        </div>
      </mat-toolbar-row>
    </div>
  </mat-toolbar>
</div>
